import styled from "styled-components";
import { 
  Form as AntForm,
  Typography as AntTypography, 
  Input as AntInput,
  Button as AntButton,
} from "antd";
import { BackArrow } from '@assets';
import { AuthBg } from "@assets/auth";
import lightTheme from '@styles/theme';

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-image: url(${AuthBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0px 16px;
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

export const ArrowIconWrapper = styled.div`
  width: 50px;
  height: 50px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  cursor: pointer;
`
export const BackIcon = styled(BackArrow)`
  width: 15px;
  height: 11px;
`;

export const SkipButton = styled(AntButton)`
  background-color: #FFFFFF;
  border: none;
  text-align: center;
  width: 91px;
  height: 35px;
  float: right;
  margin: 0 9px 0 0;
  border-radius: 30px;
  color: #C21C05 !important;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const ContentContainer = styled.div`
  width: 100%;
  margin: 259px auto 24px;

  @media (max-height: 700px) {
    margin-top: 200px !important;
  }
`

export const Title = styled(AntTypography.Title)`
  color: #FFF !important;
  text-align: center;
  font-size: 24px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: normal !important;
  text-align: center;
  font-style: normal;
  font-family: Plus Jakarta Sans;
  margin: 0 0 24px 0 !important;
` 

export const Form = styled(AntForm)`
  width: 100%;
  text-align: center;

  .ant-form-item {
    margin-bottom: 32px !important;
  }

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 24px;
  }

  .ant-form-item-label {
    margin-left: 24px;
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #E1A59C;
    font-size: 14px;
    font-family: Plus Jakarta Sans;
    font-style: normal;
    font-weight: 400;
  }

  input {
    height: 52px;
    border: 1px solid #e1cce0;
    border-radius: 27px;
    text-align: center;
  }

  .ant-btn-primary {
    width: 170px;
    height: 52px;
    border-radius: 26px !important;
  }
`;

export const Input = styled(AntInput)`
  -moz-appearance: textfield;
;

  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  && {
    text-align: left;
    padding-left: 24px;
    color: #181E1F;
    font-size: 16px;
    font-family: Plus Jakarta Sans;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;


